module.exports = __webpack_public_path__ + "img/146.5.ffac387d.png";